import React from "react";
import { seriesContacts, categories, getGroupedStackSeries } from "./data";
import { ChartsSetWrapper } from "../../../../../components";

const BarList = () => {
  return (
    <div className="flex-1 flex overflow-auto">
      <div className="flex-1  grid grid-cols-2 auto-rows-[400px] gap-4">
        <ChartsSetWrapper
          title="Bar Chart with Scrolling"
          type="bar"
          series={seriesContacts}
          categories={categories}
          options={{
            padding: { left: 60 },
            axis: {
              y: {
                scroll: { enabled: true },
              },
            },
            bar: {
              fixedHeight: 15,
              gap: 1,
              radius: 0,
              groupGap: 40,
            },
          }}
        />
        <ChartsSetWrapper
          title="Bar Chart with Scrolling"
          type="bar"
          series={seriesContacts}
          categories={categories}
          options={{
            padding: { left: 60 },
            axis: {
              y: {
                clampMinZero: true,
                scroll: { enabled: true },
              },
            },
            bar: {
              fixedHeight: 35,
              gap: 5,
              radius: 0,
              groupGap: 3,
              stacked: true,
            },
            showLabels: {
              show: true,
              color: "white",
            },
          }}
        />

        <ChartsSetWrapper
          title="Bar Chart with Options"
          type="bar"
          series={seriesContacts}
          categories={categories}
          options={{
            colors: ["primary-800", "info-500", "danger-500"],
            padding: { top: 40, right: 30, bottom: 40, left: 60 },
            axis: {
              color: "gray-200",
              labelColor: "gray-400",
              edgePadding: 50,
              y: {
                scroll: { enabled: true },
                gridLines: 6,
                //clampMinZero: true,
              },
            },
            grid: {
              color: "info-100",
              dasharray: "1 1",
              strokeWidth: 2,
              horizontal: true,
              vertical: true,
              background: "primary-50",
            },
            showLabels: {
              show: true,
              valueDisplay: "value",
              color: "gray-400",
              fontSize: 8,
              strategy: "hide",
            },
            background: "gray-100",
            area: {
              stroke: { width: 0.3, curve: "straight" },
              fill: { type: "gradient", opacity: 0.1 },
              markers: { size: 1 },
            },
            legend: {
              mode: "select",
            },
          }}
        />
        <div className="col-span-2">
          <ChartsSetWrapper
            title="Bar Chart with Scrolling"
            type="bar"
            series={getGroupedStackSeries()}
            categories={categories}
            options={{
              padding: { left: 60 },
              axis: {
                y: {
                  clampMinZero: true,
                  scroll: { enabled: true },
                },
              },
              bar: {
                fixedHeight: 200,
                gap: 10,
                radius: 0,
                groupGap: 1,
                stacked: true,
                grouped: true,
              },
              showLabels: {
                show: true,
                color: "white",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BarList;
